import React from "react";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import BottomNav from "./BottomNav";
import AppStoreBanner from "./AppStoreBanner";
import PendingRedemptionModal from "./PendingRedemptionModal";
import PushPrimer from "./PushPrimer";
import { useTheme } from "../context/ThemeContext";
import { useAuth } from "../context/AuthContext";
import { useTablet } from "../hooks/useTablet";

export default function MobileLayout() {
  const { theme } = useTheme();
  const { user, loading } = useAuth();
  const { tablet } = useTablet();
  const light = theme === "light";

  return (
    <div className="mobile-container" style={{ background: "var(--ang-bg)", minHeight: "100vh", position: "relative",
      maxWidth: tablet ? "100%" : undefined, paddingLeft: tablet ? "116px" : undefined }}>
      {/* Subtle brand watermark — top-right corner (на планшете логотип уже в боковой панели) */}
      {!tablet && (
      <img
        src={light ? "/logo-dark.png" : "/logo-transparent.png"}
        alt=""
        aria-hidden="true"
        data-testid="brand-watermark"
        style={{
          position: tablet ? "absolute" : "fixed",
          top: "14px",
          right: tablet ? "28px" : "10px",
          height: tablet ? "34px" : "28px",
          width: "auto",
          opacity: light ? 0.5 : 0.35,
          pointerEvents: "none",
          zIndex: 5,
          filter: light ? "none" : "drop-shadow(0 0 6px rgba(197,160,89,0.25))",
          maxWidth: "120px",
          objectFit: "contain",
        }}
      />
      )}
      <div style={{ paddingBottom: tablet ? "24px" : "72px", maxWidth: tablet ? "1240px" : undefined,
        margin: tablet ? "0 auto" : undefined }}>
        {!loading && !user && (
          <Link to="/auth" data-testid="guest-login-cta"
            style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
              background: "var(--ang-gold)", color: "#1A1A1A", textDecoration: "none",
              fontFamily: "Manrope", fontSize: "12px", fontWeight: 800, letterSpacing: "0.06em",
              textTransform: "uppercase", padding: "12px 14px", position: "sticky", top: 0, zIndex: 20 }}>
            Войти / Получить VIP-привилегии
          </Link>
        )}
        <Outlet />
      </div>
      <BottomNav />
      <AppStoreBanner />
      {/* Global polling for manager-initiated bonus redemption requests */}
      {user && <PendingRedemptionModal />}
      {/* Первый вход в Android-приложении: объяснение + системный запрос разрешения */}
      {user && <PushPrimer />}
    </div>
  );
}
